export default "__VITE_ASSET__b744ef5c__"